import React from 'react';
import { defineMessages } from 'react-intl';
import Isvg from 'react-inlinesvg';

import { bem } from 'helpers/class-name';
import { ILLUSTRATIONS, ICONS } from 'constants/icons';
import Message from 'components/Message';

import './DataComingSoon.scss';

const { block, element } = bem('data-coming-soon');

const messages = defineMessages({
  comingSoon: {
    id: 'smart-tools.data-coming-soon.coming-soon',
    defaultMessage: 'SmartSpot data coming soon. Stay tuned!',
  },
});

const DataComingSoon = () => {
  return (
    <div className={block()}>
      <div className={element('container')}>
        <div className={element('soon-text-line')}>
          <Isvg className={element('icon')} src={ICONS.alertBlack} />
          <Message message={messages.comingSoon} />
        </div>
        <div className={element('chart')}>
          <Isvg className={element('chart-bars')} src={ILLUSTRATIONS.chartBars} />
        </div>
      </div>
    </div>
  );
};

export default DataComingSoon;
